<template>
    <div>
        <LoaderComponent v-if="appStore.isLoaderActive()" />
        <Component :is="layout">
            <RouterView />
        </Component>
        <Toast />
    </div>
</template>

<script setup lang="ts">
    import Toast from 'primevue/toast'
    import { onBeforeUnmount, onMounted, shallowRef } from 'vue'
    import { RouterView } from 'vue-router'

    import LoaderComponent from '@/components/LoaderComponent.vue'
    import { useLayout } from '@/layouts/layout'
    import router from '@/router'
    import { useAppStore } from '@/stores/app'

    // data
    const layout = shallowRef('div')
    router.afterEach((to) => {
        layout.value = (to.meta.layout as string || 'Default')
    })

    const appStore = useAppStore()

    // methods
    const onWindowResized = () => {
        appStore.resizeHandler()
    }

    const { setTheme } = useLayout()

    onMounted(() => {
        onWindowResized()
        window.addEventListener('resize', onWindowResized)
        appStore.resizeHandler()
        appStore.setJWTCookie()
        setTheme()
    })

    onBeforeUnmount(() => {
        window.removeEventListener('resize', onWindowResized)
    })
</script>
